export default __webpack_public_path__ + "media/images/brands/le-creuset-b285f74765f4ce44c3c63bef61a79dde.png";